
import React, { useEffect, useState } from 'react';
import { BASEAPIURL, token } from '../../env';

const NoticeList = ({ refreshKey, onEdit }) => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingNotice, setEditingNotice] = useState(null);
  const [formData, setFormData] = useState({
    Heading: '',
    Description: '',
    StartDate: '',
    EndDate: '',
    Document: null,
  });

  // Fetch notices from API
  useEffect(() => {
    const fetchNotices = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "tokenData": token
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      try {
        console.log("Using token:", token);

        const response = await fetch(`${BASEAPIURL}/GetNotice`, requestOptions);

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        console.log("API Response:", data);

        if (data && data.data && Array.isArray(data.data)) {
          // Show all notices without any date filtering
          setNotices(data.data);
        } else {
          console.error("Unexpected response format:", data);
          setNotices([]);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching notices:", error);
        setLoading(false);
      }
    };

    fetchNotices();
  }, [refreshKey]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'Document') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formdata = new FormData();
    formdata.append("token", token);
    formdata.append("Heading", formData.Heading);
    formdata.append("Description", formData.Description);
    formdata.append("StartDate", formData.StartDate);
    formdata.append("EndDate", formData.EndDate);

    if (formData.Document) {
      formdata.append("FileType", formData.Document);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    try {
      const response = await fetch(`${BASEAPIURL}/InsertNotice`, requestOptions);
      const result = await response.text();
      console.log("Success:", result);
      
      // Reset form and close modal
      setFormData({
        Heading: '',
        Description: '',
        StartDate: '',
        EndDate: '',
        Document: null,
      });
      setShowForm(false);
      
      // Refresh notices
      window.location.reload();
    } catch (error) {
      console.error("Error submitting notice:", error);
    }
  };

  // Edit notice handler
  const handleEdit = (notice) => {
    setEditingNotice(notice);
    setFormData({
      Heading: notice.Heading,
      Description: notice.Description,
      StartDate: notice.StartDate,
      EndDate: notice.EndDate,
      Document: null,
    });
    setShowForm(true);
  };

  // Close form without saving
  const handleCloseForm = () => {
    setShowForm(false);
    setEditingNotice(null);
    setFormData({
      Heading: '',
      Description: '',
      StartDate: '',
      EndDate: '',
      Document: null,
    });
  };

  // Debugging output for notices state
  console.log("Notices state:", notices);

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="text-center">Notices</h1>
        <button className="btn btn-success" onClick={() => setShowForm(true)}>
          + Add Notice
        </button>
      </div>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>S.No</th>
                <th>Heading</th>
                <th>Description</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Document</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {notices.length > 0 ? (
                notices.map((notice, index) => (
                  <tr key={notice.SNo || notice.id || index}>
                    <td>{index + 1}</td>
                    <td>{notice.Heading}</td>
                    <td>{notice.Description}</td>
                    <td>{new Date(notice.StartDate).toLocaleDateString()}</td>
                    <td>{new Date(notice.EndDate).toLocaleDateString()}</td>
                    <td>
                      {notice.Document ? (
                        <div>
                          {notice.Document.endsWith(".pdf") && (
                            <iframe
                              src={notice.Document}
                              width="100%"
                              height="200"
                              title="Notice Document"
                              style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                            ></iframe>
                          )}
                          <a
                            href={notice.Document}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary mt-2"
                            download
                          >
                            Download
                          </a>
                        </div>
                      ) : (
                        <span className="text-muted">No Document</span>
                      )}
                    </td>
                    <td>
                      <button 
                        className="btn btn-sm btn-warning" 
                        onClick={() => handleEdit(notice)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No notices available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal Form */}
      {showForm && (
        <div className="modal show d-block bg-light" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingNotice ? "Edit Notice" : "Add New Notice"}
                </h5>
                <button type="button" className="btn-close" onClick={handleCloseForm}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Heading"
                      value={formData.Heading}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      name="Description"
                      value={formData.Description}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Start Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="StartDate"
                        value={formData.StartDate}
                        onChange={handleInputChange}
                        min="1000-01-01T00:00"
                        max="9999-12-31T23:59"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">End Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="EndDate"
                        value={formData.EndDate}
                        onChange={handleInputChange}
                         min="1000-01-01T00:00"
                        max="9999-12-31T23:59"
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Document (Optional)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="Document"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseForm}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {editingNotice ? "Update" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoticeList;